import styled, { css } from 'styled-components';

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  //max-width: 900px;
  width: 100%;
  height: 100%;
  background-color: #66666690;
  font-family: Spoqa Han Sans Neo;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-start;
`;
const Inner = styled.div`
  width: 100%;
  height: 100%;
  background-color: #fff;
`;
const Top = styled.div`
  width: 100%;
  padding: 16px 8px 16px 16px;
  height: 56px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  img {
    cursor: pointer;
  }
`;

const SignUpBox = styled.div`
  width: 100%;
  padding: 20px;
  font-size: 14px;
  font-weight: 500;
  color: #222;
`;
const BeforeLoginBox = styled.div`
  width: 100%;
  gap: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const AfterLoginBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  display: flex;
`;
const UserNameBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  color: #616161;
`;
const UserName = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2px;
  color: #222;
`;

const MemberShip = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const BadgeStatusGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  font-size: 14px;
`;

const MemberShipBadge = styled.div<{
  type: string | null | undefined;
}>`
  height: 24px;
  padding: 2px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;

  ${({ type }) => {
    switch (type) {
      case 'P':
        return css`
          background:
            linear-gradient(to right, #008aff, #6900f3),
            linear-gradient(to right, #3f9bff, #7c29fb);
          background-origin: border-box;
          background-clip: padding-box, border-box;
          border: 2px solid transparent;
          border-radius: 4px;
        `;
      case 'S':
        return css`
          background:
            linear-gradient(to right, #00a2e7, #aad545),
            linear-gradient(to right, #3cb5de, #aad545);
          background-origin: border-box;
          background-clip: padding-box, border-box;
          border: 2px solid transparent;
          border-radius: 4px;
        `;
      case 'T':
        return css`
          background:
            linear-gradient(to right, #ff983b, #ff29c5),
            linear-gradient(to right, #ffb777, #ff5dd3);
          background-origin: border-box;
          background-clip: padding-box, border-box;
          border: 2px solid transparent;
          border-radius: 4px;
        `;
      case undefined:
      case null:
      default:
        return css`
          background:
            linear-gradient(to right, #c4c6cc, #85898e),
            linear-gradient(to right, #e0e1e6, #bdc1c7);
          background-origin: border-box;
          background-clip: padding-box, border-box;
          border: 2px solid transparent;
          border-radius: 4px;
        `;
    }
  }}
`;

const MemberShipStatus = styled.span<{
  type: string | null | undefined;
}>`
  font-family: 'Paperlogy';
  font-weight: 700;
  color: ${({ type }) =>
    type === 'P'
      ? '#6507F4'
      : type === 'S'
        ? '#94BF08'
        : type === 'T'
          ? '#FF29C5'
          : '#898D92'};
`;

const MemberShipDate = styled.span`
  font-size: 14px;
  font-weight: 500;
  font-family: Spoqa Han Sans Neo;
  color: #222222;
`;

const MemberShipLink = styled.div`
  height: 24px;
  width: 90px;
  border-radius: 4px;
  background-color: #008aff;
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: row;
  cursor: pointer;
  padding-left: 4px;
`;

const MyPageButtonBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
`;
const FindIdBox = styled.div`
  margin-top: 4px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  color: #616161;
`;
const LoginButton = styled.span`
  width: 100%;
  height: 55px;
  border-radius: 8px;
  background-color: #008aff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
`;
const SignUpButton = styled.span`
  flex: 1;
  height: 32px;
  border-radius: 4px;
  background-color: #008aff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
`;

export const s = {
  Container,
  Inner,
  Top,
  SignUpBox,
  LoginButton,
  SignUpButton,
  BeforeLoginBox,
  FindIdBox,
  AfterLoginBox,
  UserNameBox,
  UserName,
  MyPageButtonBox,
  MemberShip,
  BadgeStatusGroup,
  MemberShipBadge,
  MemberShipStatus,
  MemberShipDate,
  MemberShipLink,
};
